/* eslint-disable quote-props */

import { ADMIN_ROLES } from "../auth";

import { teamSelector } from "./selectors";
import { AppState } from "./model";

export const routes = {
    "/teams": {
        title: "Teams",
        authorize: [ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/create": {
            authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
            title: "Create Team"
        },
        "/:teamId": {
            title: (state: AppState) => teamSelector(state) ? teamSelector(state).name : "Team",
            "/edit": {
                title: "Edit",
                authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
            }
        }
    }
};
